import { Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { basePath } from '@config/base.config.js';

import LayoutPublic from '@cores/layouts/LayoutPublic.jsx';
import LayoutTest from '@cores/layouts/LayoutTest.jsx';
import LayoutApp from '@cores/layouts/LayoutApp.jsx';


// Import all menu configurations
import {
  PUBLIC_MENU_CONFIG,
  APP_MENU_CONFIG,
  TEST_MENU_CONFIG,
} from '@cores/layouts/menuConfigs';

// Helper function to create lazy components from a config object
const createLazyComponents = (config) => {
  const lazyComponents = {};
  for (const key in config) {
    const item = config[key];

    // Skip lazy loading test bundles if on production build
    if (item.hideOnProd) { console.error("item.hideOnProd", item.hideOnProd, item);
      continue;
    }

    if (item.prefetch) {
      lazyComponents[key] = lazy(item.prefetch);
    }
  }
  return lazyComponents;
};
// Dynamically create lazy components from your configurations
const lazyPublicComponents = createLazyComponents(PUBLIC_MENU_CONFIG);
const lazyAppComponents = createLazyComponents(APP_MENU_CONFIG);
const lazyTestComponents = createLazyComponents(TEST_MENU_CONFIG);

// These components will be bundled and loaded on demand.
//import PgPubMapViewer from '@public/PgPubMapViewer.jsx';
import PgPubMapViewer from "@public/PgPubMapViewer.jsx"
//const PgPubAbout = lazy(() => import('@public/tests/PgPubAbout.jsx'));

import PgPubLogin from '@public/PgPubLogin.jsx';
import LoginCallback from '@public/loginCallback';


import PgPubLogout from '@public/PgPubLogout.jsx';
import SsoAuth from '@apps/pages/PgAppSsoAuth.jsx';

import PgAppHome from '@apps/pages/PgAppHome.jsx';

//import PgAppData from '@apps/pages/PgAppData.jsx';
import PgPubPieMap from '@public/tests/PgPubPieMap';
import PgPubTestAuth from '@public/tests/PgPubTestAuth';
import PgPubTestAuthorization  from '@public/tests/PgPubTestAuthorization';
import PgPubNotFound from '@public/PgPubNotFound.jsx';


import ReservationsWithMap from '@apps/components/mapViewers/tests/ReservationsWithMap';
import { ProtectedRoute } from '@cores/security/ProtectedRoute.jsx';
//const Forbidden = lazy(() => import('@cores/security/Forbidden.jsx'));
//import WellArcGISMapper from '@apps/components/mapViewers/WellArcGISMapper';
import SpDataViewer from '@apps/components/SpViewers';
// test part
//import MapViewerWithShellPanelSplit from '@apps/components/mapViewers/tests/MapViewerWithShellPanelSplit.jsx';
// const MapViewerWithLRPanels = lazy(() => import('@apps/components/mapViewers/tests/MapViewerWithLRPanels.jsx'));


const AppRoutes = () => {
  return (
    <Routes>
      <Route path={`${basePath}/notfound`} element={<PgPubNotFound />} />
      <Route
        path={`${basePath}/*`}
        element={<LayoutPublic />}
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <Route index element={<PgPubMapViewer />} />
        <Route path="login" element={<PgPubLogin />} />
        <Route path="loginCallback/*" element={<LoginCallback />} />
        <Route path="logout" element={<PgPubLogout />} />
               
        <Route path="ssoauth" element={<SsoAuth />} />
        <Route path="abc" element={<PgPubTestAuth />} />
        <Route path="abcd" element={<PgPubTestAuthorization />} />

        <Route path="piemap" element={<PgPubPieMap />} />
       
       {/* Dynamically render routes from the PUBLIC_MENU_CONFIG */}
        {Object.keys(lazyPublicComponents).map((key) => {
          const Component = lazyPublicComponents[key];
          const path = PUBLIC_MENU_CONFIG[key].path.startsWith('/') ? PUBLIC_MENU_CONFIG[key].path.substring(1) : PUBLIC_MENU_CONFIG[key].path;
          return (
            <Route
              key={key}
              path={path}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Component />
                </Suspense>
              }
            />
          );
        })}
        
        <Route path="*" element={<Navigate to={`${basePath}/notfound`} replace />} />
      </Route>

      <Route path={`${basePath}/app/*`} element={<ProtectedRoute><LayoutApp /></ProtectedRoute>}>
        <Route index element={<PgAppHome />} />
        <Route path="logout" element={<PgPubLogout />} />
        {/* Dynamically render routes from the APP_MENU_CONFIG */}
        {Object.keys(lazyAppComponents).map((key) => {
          const Component = lazyAppComponents[key];
          const path = APP_MENU_CONFIG[key].path.replace('/app/', ''); // Adjust path for nested routes
          return (
            <Route
              key={key}
              path={path}
              element={
                <Suspense fallback={<div>Loading {APP_MENU_CONFIG[key].text}...</div>}>
                  <Component />
                </Suspense>
              }
            />
          );
        })}
      </Route>

      <Route path={`${basePath}/test/*`} element={<LayoutTest />}>
         <Route index element={<SpDataViewer />} />
        <Route path="spviewer" element={<SpDataViewer />} /> 
        <Route path="reservations" element={<ReservationsWithMap />} />
        <Route path="logout" element={<PgPubLogout />} />
            {/* Dynamically render routes from the TEST_MENU_CONFIG */}
            {Object.keys(lazyTestComponents).map((key) => {
              const Component = lazyTestComponents[key];
              const path = TEST_MENU_CONFIG[key].path.replace('/test/', ''); // Adjust path for nested routes
              return (
                <Route
                  key={key}
                  path={path}
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <Component />
                    </Suspense>
                  }
                />
              );
            })}
      </Route>
    </Routes>
  );
};

export default AppRoutes;